import store from '@/store'
import actions from '@/store/actions'
import mutations from '@/store/mutations'

export const getAllDictionaries = async () => {
  const data = await store.dispatch(actions.callApi, { url: 'sys/bootstrap' })

  await store.commit(mutations.SET_ADMIN_ROLE, data.isAdmin)
  await store.commit(mutations.SET_AREA_MANAGER_ROLE, data.isAreaManager)
  await store.commit(mutations.SET_INSIGHTS_ROLE, data.isInsightsViewer)
  await store.commit(mutations.SET_CONTRACT_PROJECTS, data.projects)
  await store.commit(mutations.SET_CONTRACT_PACKAGES, data.packages)
  await store.commit(mutations.SET_CONTRACT_TYPES, data.types)
  await store.commit(mutations.SET_STEPS_NAMES, data.workflowStepsNames)
  await store.commit(mutations.SET_NOTIFICATION_DAYS, data.notificationsDays)
  await store.commit(mutations.SET_WORKFLOWS_TYPES, data.workflowsTypes)
  await store.commit(mutations.SET_CURRENCIES, data.currencies)
  await store.commit(mutations.SET_VARIATIONS_STAGES, data.variationsStages)
  await store.commit(mutations.SET_STATUSES, data.statuses)
  await store.commit(mutations.SET_CATEGORIES, data.categories)
  await store.commit(mutations.SET_WORKSTREAMS, data.workstreams)
  await store.commit(mutations.SET_AREAS, data.areas)
  await store.commit(mutations.SET_RISKS, data.risks)
  await store.commit(mutations.GUARANTEES_NAMES, data.guaranteesNames)
}
